import React, { useState } from 'react'
import { Flex } from '../../../Components/Common/Flex'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { columnProps } from '../../../Services/Functions'
import { Button } from '../../../Components/Common/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { useCQuery } from '../../../Services/QueryCache'
import { Text } from '../../../Components/Common/Text'
import { deleteDocument } from './Functions'
import { Modal } from '../../../Components/Common/Modal'
import { FC, invalidateQuery } from '../../../Services'
import { InputSwitch } from 'primereact/inputswitch'

export const MappedDocumentsList = () => {
  const { environmentId } = useParams()
  const { data: mappedDocuments = [] } = useCQuery(['mappedDocuments', environmentId])
  const [modalVisible, setModalVisible] = useState(false)
  const [idToDelete, setIdToDelete] = useState('')

  const navigate = useNavigate()

  const BtnActionProc = ({ id }) => (
    <Flex row style={{ width: '100%' }}>
      <Button round tooltip='Visualizza' icon='fa-duotone fa-pen' style={{ marginRight: 10 }} onClick={() => navigate('/environments/' + environmentId + '/mapDocument/' + id)} />
      <Modal visible={modalVisible} header='Cancellazione documento' onHide={() => setModalVisible(false)}>
        <Flex fw>
          <Text value='Vuoi cancellare questo documento?' />
          <Flex fw row jb style={{ marginTop: 20 }}>
            <Button label='Annulla' icon='fa-duotone fa-trash' onClick={() => setModalVisible(false)} />
            <Button
              label='Conferma' icon='fa-duotone fa-check' onClick={() => {
                deleteDocument(idToDelete)
                setModalVisible(false)
              }}
            />
          </Flex>
        </Flex>
      </Modal>
      <Button round tooltip='Elimina' icon='fa-duotone fa-trash' onClick={() => { setIdToDelete(id); setModalVisible(true) }} />
    </Flex>
  )

  return (
    <Flex fw>
      <Flex fw jb row>
        <div style={{ width: '20%' }} />
        <Text value='Elenco Documenti' size={22} bold />
        <Flex ae style={{ width: '20%' }}>
          <Button label='Aggiungi' icon='fa-duotone fa-plus' onClick={() => navigate('/environments/' + environmentId + '/mapDocument/new')} />
        </Flex>
      </Flex>
      <DataTable
        style={{ width: '100%', marginTop: 20 }} filterDisplay='row' className='TableSignatures' sortField='startDate' sortOrder={1}
        value={mappedDocuments} emptyMessage='Nessuna documento caricato' responsiveLayout='scroll' paginator rows={10}
      >
        <Column field='name' {...columnProps('Nome')} />
        <Column
          field='disabled' {...columnProps('Abilitato')}
          style={{ border: 'none', width: 220, height: 15, textAlign: 'center' }}
          body={(rowData) =>
            <InputSwitch
              checked={!rowData.disabled}
              onChange={({ value }) => FC.service('mappedDocuments').patch(rowData.id, { disabled: !value }).then(() => invalidateQuery(['mappedDocuments']))}
            />}
        />
        <Column
          field='removeAnnotations' {...columnProps('Rimuovi Annotazioni')}
          style={{ border: 'none', width: 220, height: 15, textAlign: 'center' }}
          body={(rowData) =>
            <InputSwitch
              checked={rowData.removeAnnotations}
              onChange={({ value }) => FC.service('mappedDocuments').patch(rowData.id, { removeAnnotations: value }).then(() => invalidateQuery(['mappedDocuments']))}
            />}
        />
        <Column field='createdAt' {...columnProps('Data')} body={(row) => new Date(row.createdAt).toLocaleString()} style={{ width: 200 }} />
        <Column style={{ border: 'none', width: 220, height: 15, textAlign: 'center' }} body={(props) => <BtnActionProc {...props} />} />
      </DataTable>
    </Flex>
  )
}
